export default __webpack_public_path__ + "static/media/img-0033.3e24055e.png";